module.exports = __webpack_public_path__ + "static/media/EU.51573b67.svg";